import AsyncStorage from '@react-native-async-storage/async-storage';

const announcementDismissedKey = (userId: string, announcementId: string) =>
  `home.announcement.dismissed.v1.${userId}.${announcementId}`;

export async function isAnnouncementDismissed(
  userId: string,
  announcementId: string,
): Promise<boolean> {
  const v = await AsyncStorage.getItem(announcementDismissedKey(userId, announcementId));
  return v === '1';
}

export async function dismissAnnouncement(
  userId: string,
  announcementId: string,
): Promise<void> {
  await AsyncStorage.setItem(announcementDismissedKey(userId, announcementId), '1');
}
